/**
 * Settings Service
 * API integration for user preferences
 */

import { apiClient } from './api';
import type { UserPreferences, UpdatePreferencesPayload } from '@shared/types/preferences';

class SettingsService {
  /**
   * Get user preferences
   */
  async getPreferences(): Promise<UserPreferences> {
    const response = await apiClient.get<{ data: UserPreferences }>('/api/v1/settings/preferences');
    return response.data.data;
  }

  /**
   * Update user preferences
   */
  async updatePreferences(payload: UpdatePreferencesPayload): Promise<UserPreferences> {
    const response = await apiClient.put<{ data: UserPreferences }>(
      '/api/v1/settings/preferences',
      payload
    );
    return response.data.data;
  }

  /**
   * Reset preferences to defaults
   */
  async resetPreferences(): Promise<UserPreferences> {
    const response = await apiClient.post<{ data: UserPreferences }>(
      '/api/v1/settings/preferences/reset'
    );
    return response.data.data;
  }
}

export const settingsService = new SettingsService();
